export default __webpack_public_path__ + "static/media/logo.5683345a.png";